import React, {useState} from 'react';
import axios, {AxiosInstance} from 'axios'; // eslint-disable-line no-unused-vars
import {parse, stringify} from 'flatted';

/** @type {import('react').Context<TApiContext>} */
const ApiContext = React.createContext(undefined, undefined);

const ApiProvider = (props) => {
    const [totalLoads, setTotalLoads] = useState(0);

    const api = axios.create({
        transformRequest: [
            (data, _) => {
                return stringify(data);
            },
            ...axios.defaults.transformRequest,
        ],
        headers: {'content-type': 'application/json'},
    });

    api.interceptors.request.use((config) => {
        setLoading(true);
        return config;
    });

    api.interceptors.response.use(
        (response) => {
            setLoading(false);
            return response;
        },
        (error) => {
            setLoading(false);
            console.error(error);
            alert(error);
            return Promise.reject(error);
        }
    );
    const [API] = useState({...api});

    function setLoading(isLoading) {
        if (isLoading) {
            setTotalLoads((prev) => prev + 1);
        } else {
            setTotalLoads((prev) => prev - 1);
        }
    }

    return <ApiContext.Provider value={{API, setLoading, totalLoads}}>{props.children}</ApiContext.Provider>;
};

export {ApiProvider, ApiContext};
